import 'whatwg-fetch';

const tokenProviderFactory = () => {
  let userJWT = null;

  return (refresh) => {
    if (userJWT && !refresh) {
      return Promise.resolve(userJWT);
    }

    return fetch(`/token${refresh ? '?refresh=true' : ''}`, {
      credentials: 'same-origin'
    })
      .then((response) => {
        if (response.status > 199 && response.status < 300) {
          return response.json();
        }
        if (response.status === 401) {
          window.location.reload();
        }
        throw response;
      })
      .then((data) => {
        userJWT = data.user_jwt;
        return userJWT;
      });
  };
};

export default tokenProviderFactory;
